<template>
  <div id="app">
    <topHeader  v-if=" status!='isIndex' && status!='index' && status!='mobilerecharge' && status!='privacy_voice' && status!='marketing'"></topHeader>
    <mobileHeader v-if="status=='index'"></mobileHeader>
    <router-view/>
    <bFooter  v-if=" status!='isIndex' && status!='index' && status!='mobilerecharge' && status!='privacy_voice' && status!='marketing'"></bFooter>
    <!-- <mobileFooter v-if="status=='index'"></mobileFooter> -->
  </div>
</template>
<script>
import TopHeader from './components/header'
import BFooter from './components/footer'
import MobileHeader from './mobilComponents/mobilHeader'
import MobileFooter from './mobilComponents/mobilFooter'
export default {
  name: 'App',
  components:{
    TopHeader,
    BFooter,
    MobileHeader,
    MobileFooter
  },
  computed:{
    status(){
      console.log(this.$store.state.status);
      return this.$store.state.status;
    }
  },
  mounted(){
    console.log(this.$store.state.status);
  },
  mounted(){
    // let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    // if(flag) {
    //   this.$router.replace('/mobilindex');
    // }else{
    //   this.$router.replace('/');
    // }
  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}

.gw{
  width:1180px;
  min-width: 1180px;
  margin: 0 auto;
  display: inline-block;
  overflow: hidden;
}

.fl{
  float: left;
}



html,body{
    height:100%;
    width:100%;
    padding:0px;
    border:0px;
    margin:0px;
}
#app {
  font-family: PingFangSC-Semibold;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 100%;
  height: 100%;
  /* background-image: url("./assets/bg.png"); */
  
}

ul,li{
  list-style:none;
}

.clearfix{
  zoom:1;
}
.clearfix::after,.clearfix::before{
  content: "";
  display: block;
  clear: both;
}

.loading-component{
  width:100%;
  height:100%;
  position:fixed;
  background:rgba(0,0,0,.6);
  top:0;
  left:0;
  z-index:9999;
}

.loading-component .loading-box{
  width:70px;
  height:70px;
  position:absolute;
  left:0;
  right:0;
  margin:0 auto;
  top: 40%;
}

.loading-box .loading-item{
  display: inline-block;
  width: 8px;
  height: 100%;
  /* background:#F54E31; */
  margin-right: 3px;
  animation: loadings 1.2s infinite ease-in-out;
  -webkit-animation: loadings 1.2s infinite ease-in-out;
}

.loading-box .loading-item.loading-item2{
  animation-delay: -1.1s;
  -webkit-animation-delay: -1.1s;
}
.loading-box .loading-item.loading-item3{
  animation-delay: -1.0s;
  -webkit-animation-delay: -1.0s;
}

.loading-box .loading-item.loading-item4{
  animation-delay: -0.9s;
  -webkit-animation-delay: -0.9s;
}
.loading-box .loading-item.loading-item5{
  animation-delay: -0.8s;
  -webkit-animation-delay: -0.8s;
}
.loading-box .loading-item.loading-item6{
  animation-delay: -0.7s;
  -webkit-animation-delay: -0.7s;
}

@-webkit-keyframes loadings{
  0%, 40%, 100% {-webkit-transform:scaleY(.4);}
  20%{-webkit-transform:scaleY(1);}
}
@keyframes loadings {
  0%, 40%, 100%{
    transform: scaleY(.4);
    -webkit-transform:scaleY(.4);
  }
  20%{
    transform: scaleY(1);
    -webkit-transform: scaleY(1);
  }
}

@media (min-width: 1366px) {
  .gw{
    width:1280px;
    min-width: 1280px;
  }
}

@media (min-width: 1440px) {
  .gw{
    width:1380px;
    min-width: 1380px;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue